import { useEffect } from 'react';
import Resultats from '../UI/Resultats.jsx';
import { ClappingIcon } from './ClappingIcon.jsx';

function Remerciement({
    interaction,
    resultatsVote,
    fetchResults
}) {

    /** Le traitement des participations par l'API est asynchrone récupérer le
     * résultat par interval est donc nécessaire pour obtenir le dernier résultat
     */
    useEffect(() => {
        if (interaction.show_results && fetchResults) {
            const interval = setInterval(fetchResults, 2500);
            return () => {
                clearInterval(interval);
            };
        }
    }, []);
    return (
        <div className="custom-remerciement">
            {!interaction.show_results &&
                <>
                    <p className="text">Participation envoyée</p>
                    <p className="custom-text">{interaction.segment_customisation.text_thanks}</p>
                    <ClappingIcon />
                </>
            }

            {interaction.show_results && resultatsVote &&
                <>
                    <div>
                        <Resultats resultatsVote={resultatsVote} />
                    </div>
                </>
            }
        </div>

    )
}
export default Remerciement;